import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

// Definimos el contenedor principal del Footer con estilo similar al NavBar
const FooterContainer = styled.footer`
  background: ${({theme}) => theme.colors.surfaceAlpha || 'rgba(0, 0, 0, 0.8)'};
  backdrop-filter: blur(12px) saturate(140%);
  color: ${({theme}) => theme.colors.text || 'white'};
  padding: ${({theme}) => theme.space?.lg || '40px'} 0;
  border-top: 1px solid ${({theme}) => theme.colors.border || 'rgba(255, 255, 255, 0.1)'};
  box-shadow: ${({theme}) => theme.shadows?.sm || '0 -4px 6px -1px rgba(0, 0, 0, 0.1)'};
  transition: background var(--motion-normal, 0.3s ease), box-shadow var(--motion-normal, 0.3s ease);
`;

const Container = styled.div`
  max-width: 70rem;
  margin: 0 auto;
  padding: 0 ${({theme}) => theme.space?.lg || '2rem'};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// Sección para los enlaces de redes sociales
const SocialLinks = styled.div`
  margin-bottom: ${({theme}) => theme.space?.md || '20px'};

  a {
    color: ${({theme}) => theme.colors.text || 'white'};
    margin: 0 10px;
    font-size: 1.5rem;
    transition: color var(--motion-fast, 0.2s ease), transform var(--motion-fast, 0.2s ease);

    &:hover {
      color: ${({theme}) => theme.colors.primary || '#ff9800'};
      transform: translateY(-2px);
    }
  }
`;

// Sección de navegación (Legal, Privacidad, etc.)
const NavLinks = styled.div`
  margin-bottom: ${({theme}) => theme.space?.md || '20px'};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${({theme}) => theme.space?.sm || '10px'};

  a {
    color: ${({theme}) => theme.colors.text || 'white'};
    padding: ${({theme}) => theme.space?.xs || '8px'} ${({theme}) => theme.space?.sm || '12px'};
    font-size: 0.9rem;
    text-decoration: none;
    transition: color var(--motion-fast, 0.2s ease), transform var(--motion-fast, 0.2s ease);
    border-radius: ${({theme}) => theme.radius?.sm || '4px'};

    &:hover {
      color: ${({theme}) => theme.colors.primary || '#ff9800'};
      transform: translateY(-2px);
      background: ${({theme}) => theme.colors.surfaceHover || 'rgba(255, 255, 255, 0.1)'};
    }
  }
`;

// Sección de información de contacto
const ContactInfo = styled.div`
  font-size: 0.9rem;
  margin-bottom: ${({theme}) => theme.space?.sm || '10px'};
  color: ${({theme}) => theme.colors.textSecondary || 'rgba(14, 13, 13, 0.7)'};

  p {
    margin: 5px 0;
  }
`;

// Derechos reservados y productor
const Copyright = styled.div`
  font-size: 0.8rem;
  border-top: 1px solid ${({theme}) => theme.colors.border || 'rgba(255, 255, 255, 0.1)'};
  padding-top: ${({theme}) => theme.space?.sm || '10px'};
  margin-top: ${({theme}) => theme.space?.md || '20px'};
  width: 100%;
  text-align: center;
  color: ${({theme}) => theme.colors.textSecondary || 'rgba(19, 17, 17, 0.7)'};
`;

const Logo = styled.img`
  height: 60px;
  margin-bottom: ${({theme}) => theme.space?.md || '20px'};
  object-fit: contain;
  transition: transform var(--motion-fast, 0.2s ease);
  
  &:hover {
    transform: translateY(-2px);
  }
`;

// Componente Footer
const Footer = () => {
  return (
    <FooterContainer>
      <Container>
        <Logo src='Logo.jpg' alt='Boxing Machine Logo'/>
        <SocialLinks>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="https://reddit.com" target="_blank" rel="noopener noreferrer" aria-label="Reddit">
            <i className="fab fa-reddit"></i>
          </a>
        </SocialLinks>
        
        <NavLinks>
          <Link to="/" aria-label="Home">Home</Link>
          <Link to="/info" aria-label="Info">Info</Link>
          <Link to="/archivo" aria-label="Archivo">Archivo</Link>
          <Link to="/legal" aria-label="Legal">Legal</Link>
          <Link to="/aviso-legal" aria-label="Aviso legal">Aviso legal</Link>
          <Link to="/privacy" aria-label="Privacidad">Privacidad</Link>
          <Link to="/cookies" aria-label="Cookies">Cookies</Link>
          <a href="/sitemap.xml" aria-label="Web Map">Web Map</a>
        </NavLinks>
        
        <ContactInfo>
          <p>Email: contacto@punchmachine.com</p>
          <p>Teléfono: +34 123 456 789</p>
        </ContactInfo>

        <Copyright>
          &copy; {new Date().getFullYear()} PunchMachine. Todos los derechos reservados. <br />
          Producido por: PunchMachine Team
        </Copyright>
      </Container>
    </FooterContainer>
  );
};

export default Footer;